/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiApiImportFiltersRetrieveParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiApiImportFiltersRetrieveParams = zod.input<
    typeof ApiApiImportFiltersRetrieveParams
>;
export type ApiApiImportFiltersRetrieveParamsOutput = zod.output<
    typeof ApiApiImportFiltersRetrieveParams
>;
